import { Trash2 } from 'lucide-react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { useDeleteInvoice } from '@/hooks/useInvoices';
import type { CustomerInvoice } from '@/apis/invoices';

interface Props {
  invoice: CustomerInvoice | null;
  onClose: () => void;
}

export function DeleteInvoiceDialog({ invoice, onClose }: Props) {
  const del = useDeleteInvoice();

  return (
    <Dialog
      open={!!invoice}
      onOpenChange={(o) => {
        if (!o && !del.isPending) onClose();
      }}
    >
      <DialogContent
        className="w-[440px] max-w-[90vw] px-8 py-10"
        closeButtonClassName="text-danger hover:bg-danger-light"
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <div className="flex justify-center pb-4">
          <div className="border-danger text-danger flex h-24 w-24 items-center justify-center rounded-full border-2">
            <Trash2 size={44} />
          </div>
        </div>
        <p className="text-center text-xl font-normal text-black">
          Delete invoice {invoice?.invoiceNumber}? This cannot be undone.
        </p>
        <div className="mt-6 flex gap-4">
          <button
            type="button"
            onClick={onClose}
            disabled={del.isPending}
            className="bg-primary-s50 text-primary-s500 flex-1 rounded-full py-3 text-base font-medium transition-colors hover:opacity-80 disabled:cursor-not-allowed disabled:opacity-50"
          >
            No
          </button>
          <button
            type="button"
            disabled={del.isPending}
            onClick={() => {
              if (!invoice) return;
              del.mutate(invoice.id, { onSuccess: onClose });
            }}
            className="bg-danger flex-1 rounded-full py-3 text-base font-medium text-white transition-colors hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {del.isPending ? 'Deleting…' : 'Yes'}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
